import { render, staticRenderFns } from "./success-snackbar.vue?vue&type=template&id=944070a6&scoped=true"
import script from "./success-snackbar.vue?vue&type=script&lang=js"
export * from "./success-snackbar.vue?vue&type=script&lang=js"
import style0 from "./success-snackbar.vue?vue&type=style&index=0&id=944070a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944070a6",
  null
  
)

export default component.exports